import { Component, Input } from '@angular/core';
import { Alert } from '../models/alert.model';

@Component({
  selector: 'app-alert-query',
  templateUrl: './alert-query.component.html',
  standalone: false
})
export class AlertQueryComponent {

  @Input() alert: Alert = {};

}
